import React from "react"

const NoRecords = () => {
  return (
    <h4 className="text-center">Sorry,There are no records at this time</h4>
  )
}

export default NoRecords
